import type {
  CoreApiRequestPayload,
  CoreItem,
  CoreItemPayload,
  ParameterID,
} from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

/**
 * Update an item by ID.
 *
 * @endpoint PATCH /api/saas/me/items/{itemId}
 * @scope saas
 * @see https://flecto.dev/api-4724225
 */
export async function updateItem(
  itemId: ParameterID,
  item: CoreItemPayload
): Promise<CoreItem> {
  const body: CoreApiRequestPayload<CoreItemPayload> = {
    data: {
      type: 'item',
      attributes: item,
    },
  }

  const response = await api.patch(`/api/saas/me/items/${itemId}`, body)
  const { data } = deserialize<CoreItem>(response.data)

  return data
}
